<template>
  <div class="relative pt-3 pb-6 md:py-5">
    <etg-loading class="size-12 text-red-50 mx-auto" />
  </div>
</template>

<script lang="ts" setup>
import EtgLoading from '@/components/common/etg-loading.vue'
</script>
